export default "__VITE_ASSET__Czri7TCS__"